import React, { useState, useEffect, useRef } from "react";

import fondJeu from "assets/puzzles/iserba/roadSafety/interieur_voiture.svg";
import deuxiemePersonnage from "assets/puzzles/iserba/roadSafety/deuxieme_personnage_tete_tournee.svg";
import interfaceGpsActive from "assets/puzzles/iserba/roadSafety/interface_gps_active.svg";
import lapin from "assets/puzzles/iserba/roadSafety/lapin.svg";
import TypewriterText from "components/shared/TypeWriterText";

const GRID_SIZE = 5;

const IserbaGame4ClickPuzzle = ({ question, onAnswer }) => {
	const [gridSize, setGridSize] = useState(0);
	const [passengerText, setPassengerText] = useState("Oh ! Un lapin");
	const [narratorText, setNarratorText] = useState(null);
	const rabitPosition = [1, 3];
	const [rabitClicked, setRabitClicked] = useState(false);
	const gridRef = useRef(null);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	const handleRabitClick = () => {
		setPassengerText(null);
		setNarratorText("*Vous regardez le lapin...*");
		setRabitClicked(true);

		setTimeout(() => {
			onAnswer({
				scene_1_correct: false,
				scene_1_errors: ["consultation-agenda"],
			});
		}, 2000);
	};

	const submitAnswer = () => {
		if (!rabitClicked) {
			onAnswer({
				scene_1_correct: true,
				scene_1_errors: [],
			});
		}
	};

	return (
		<div className="relative flex flex-col items-start non-selectable">
			<div
				ref={gridRef}
				className={`relative grid grid-cols-${GRID_SIZE} grid-rows-${GRID_SIZE} gap-0 m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)] bg-black`}
				style={{
					width: gridSize,
					height: gridSize,
					backgroundImage: `url(${fondJeu})`,
					backgroundSize: "cover",
				}}
			>
				<img
					onClick={handleRabitClick}
					src={lapin}
					alt="lapin"
					className="absolute w-[10%] h-[5%] object-contain cursor-pointer hover:scale-110 transition-all pointer-events-auto"
					style={{
						top: `${(rabitPosition[0] / GRID_SIZE) * 135}%`,
						left: `${(rabitPosition[1] / GRID_SIZE) * 114}%`,
						transform: "translate(-50%, -50%)",
						zIndex: 50,
					}}
				/>
				<img
					src={deuxiemePersonnage}
					alt="deuxiemePersonnage"
					className="absolute z-0 bottom-0 right-0 w-full"
				/>
				<img
					src={interfaceGpsActive}
					alt="interfaceGpsActive"
					className="absolute bottom-0 right-0 w-full"
				/>
				{narratorText && (
					<div className="absolute top-[5%] left-8 right-8 text-sm py-2 px-4 shadow-md mb-4 text-center bg-white">
						<TypewriterText text={narratorText} />
					</div>
				)}
				{passengerText && (
					<div className="absolute bottom-[75%] right-16 text-sm py-2 px-4 shadow-md mb-4 bg-white rounded-full">
						<TypewriterText text={passengerText} />
					</div>
				)}
			</div>

			<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
				<button
					onClick={submitAnswer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Continuer
				</button>
			</div>
		</div>
	);
};

export default IserbaGame4ClickPuzzle;
